<div class="slider-input-wrapper">
  <div class="labelText labelIdle">{{ label }}</div>
  <div class="my-1"></div>
  <div
    brnSlider
    class="finxone-slider"
    aria-label="Slider"
    [min]="min"
    [max]="max"
    [step]="step"
    [disabled]="disabled"
    [(value)]="value"
    (valueChange)="onSliderValueChange($event)"
  >
    <div brnSliderTrack class="finxone-slider-track">
      <div brnSliderRange class="finxone-slider-range"></div>
    </div>
    <div brnSliderThumb class="finxone-slider-thumb"></div>
  </div>
</div>
